<div class="modal-header">
  <h5 class="modal-title">Manage VTT Files</h5>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">
      <svg role="img"><use xlink:href="#icon-close"></use></svg>
    </span>
  </button>
</div>

<div class="modal-body" [formGroup]="vttForm">
  <!-- Language -->
  <div class="form-group">
    <label>Language</label>
    <ng-container *ngIf="!isAdding; else addLangInput">
      <select class="form-control" formControlName="language" (change)="onLanguageChange()">
        <option *ngFor="let lang of languages" [value]="lang.url">{{ lang.name }}</option>
      </select>
    </ng-container>
    <ng-template #addLangInput>
      <gs-input-material label="Enter new language name" name="Enter new language nam" placeholder="Enter new language name"
      [formControl]="vttForm.controls.languageName" formControlName="languageName" type="text">
    </gs-input-material>
      <!-- <input
        type="text"
        class="form-control"
        placeholder="Enter new language name"
        [(ngModel)]="languageName"
        [ngModelOptions]="{standalone: true}"
      /> -->
    </ng-template>
  </div>
  <div class="form-group" *ngIf="isAdding">
    <label>Language Code</label>
    <gs-input-material label="Language code" name="Language code" placeholder="Language code"
    [formControl]="vttForm.controls.language_code" formControlName="language_code" type="text">
  </gs-input-material>
  </div>
  <!-- URL Input for Adding -->
  <div class="form-group" *ngIf="isAdding">
    <label>VTT File URL</label>
    <gs-input-material label="https://example.com/file.vtt" name="https://example.com/file.vtt" placeholder="https://example.com/file.vtt"
    [formControl]="vttForm.controls.vttUrl" formControlName="vttUrl" type="text">
  </gs-input-material>
  </div>

  <!-- Animated preview/editor area -->
  <div class="preview-wrapper" [@expandBox]="showEditor ? 'expanded' : 'collapsed'">
    <!-- Loading -->
    <div class="loading-notif" *ngIf="loading">
      <div class="spinner-border spinner-sm" role="status" aria-hidden="true"></div>
      <span class="ml-2">Loading VTT content...</span>
    </div>

    <!-- Editor -->
    <div class="editor-body" *ngIf="showEditor && !loading">
      <label class="d-block mb-2">Preview / Edit</label>
      <textarea
        class="form-control vtt-textarea"
        [(ngModel)]="vttContent"
        [ngModelOptions]="{standalone: true}"
        [readonly]="loading"
        rows="12"
      ></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!isAdding">
    <button class="btn btn-outline-primary" [style.color]="'#fff'" [style.background]="this.initialState.primary_clr" (click)="toggleAddMode()">Add New</button>
    <button class="btn btn-danger" [style.color]="'#fff'"  [style.background]="this.initialState.primary_clr" (click)="deleteVTT()" [disabled]="loading || !showEditor">Delete</button>
    <button class="btn btn-primary" [style.color]="'#fff'"  [style.background]="this.initialState.primary_clr" (click)="updateVTT()" [disabled]="loading || !showEditor">Save / Update</button>
  </ng-container>

  <ng-container *ngIf="isAdding">
    <button class="btn btn-secondary" [style.color]="'#fff'"  [style.background]="this.initialState.primary_clr" (click)="toggleAddMode()">Cancel</button>
    <button class="btn btn-success" [style.color]="'#fff'"  [style.background]="this.initialState.primary_clr"(click)="addVTT()" [disabled]="loading">Add</button>
  </ng-container>

  <!-- <button class="btn btn-secondary" (click)="close()">Close</button> -->
</div>
